export default d => {
  return d;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/crossfilter2/src/identity.js
// module id = i7FY
// module chunks = 0